import React from "react";

const AccessibilityStatement = () => {
  return (
    <div className="container" style={{ padding: "2rem 1rem" }}>
      <div className="row">
        <main id="main-content" className="col-12 content-paging">
          <h1>Accessibility Statement</h1>

          <p className="lead">
            ATXFloods is committed to making its website accessible to all
            people, including those with disabilities.
          </p>

          <hr />

          <h2>Conformance Status</h2>
          <p>
            The Web Content Accessibility Guidelines (WCAG) defines requirements
            for designers and developers to improve accessibility for people
            with disabilities. It defines three levels of conformance: Level A,
            Level AA, and Level AAA.
          </p>
          <p>
            <strong>
              ATXFloods is fully conformant with WCAG 2.1 level AA.
            </strong>{" "}
            Fully conformant means that the content fully conforms to the
            accessibility standard without any exceptions.
          </p>

          <h2>Feedback</h2>
          <p>
            We welcome your feedback on the accessibility of ATXFloods. Please
            let us know if you encounter accessibility barriers on ATXFloods:
          </p>
          <ul>
            <li>E-mail: support@atxfloods.com</li>
            <li>Visitor Address: Austin, Texas</li>
          </ul>
          <p>We try to respond to feedback within 2 business days.</p>

          <h2>Technical Specifications</h2>
          <p>
            Accessibility of ATXFloods relies on the following technologies to
            work with the particular combination of web browser and any
            assistive technologies or plugins installed on your computer:
          </p>
          <ul>
            <li>HTML</li>
            <li>WAI-ARIA</li>
            <li>CSS</li>
            <li>JavaScript</li>
          </ul>
          <p>
            {" "}
            These technologies are relied upon for conformance with the
            accessibility standards used.
          </p>

          <h2>Assessment Approach</h2>
          <p>
            ATXFloods assessed the accessibility of the website by the following
            approaches:
          </p>
          <ul>
            <li>Self-evaluation using Chrome Lighthouse (v13.0)</li>
            <li>Manual Code Review and Remediation (January 2026)</li>
          </ul>

          <p className="mt-4">
            <small>This statement was created on January 25, 2026.</small>
          </p>
        </main>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
